module.exports = __webpack_public_path__ + "static/media/img-da157cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/buc-logo.png
// module id = 5280
// module chunks = 39